import React from "react";
import LabelField from "component/labelField/LabelField";
import t from "module/translations";

interface Props {
  name: string;
}

const TrainingNameLabelField: React.FC<Props> = ({ name }) => {
  return (
    <LabelField
      {...{
        caption: t.competencyManagement.training.nameText,
        label: name,
      }}
    />
  );
};

export default React.memo(TrainingNameLabelField);
